import { render, staticRenderFns } from "./pull-request.vue?vue&type=template&id=5e70599e&"
import script from "./pull-request.vue?vue&type=script&lang=ts&"
export * from "./pull-request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports